<div class="frame-content">
  <div class="frame-content__head">
    <div class="titleBlock" *ngIf="title">
      <div class="backAction" *ngIf="backAction" (click)="back()">
        <ui-icon nameIcon="arrow_back"></ui-icon>Назад
      </div>
      <h1>{{title}}</h1>
    </div>
    <div class="actions">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
  <div class="frame-content__body">
    <ng-content></ng-content>
  </div>
  <div class="frame-content__footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
